import { AbstractControl, ValidationErrors } from '@angular/forms';
import { looksLikeEmail, parseAddresses } from './push-destination-form.mapper';

/**
 * Pure validators for the push-destination dialog, extracted from the component
 * so they can be unit-tested against plain controls. Both are plain functions
 * (no instance state), so they slot directly into a control's validator array.
 *
 * Mirrors the connection-form validators pattern (SCRUM-760).
 */

/** Require an `https:` URL. Empty passes (the `required` validator owns emptiness). */
export function httpsValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:') {
      return { httpsRequired: true };
    }
  } catch {
    return { invalidUrl: true };
  }
  return null;
}

/**
 * Require at least one recipient and that every address looks like an email.
 * Empty → `{ required }`; any malformed address → `{ invalidEmail }`.
 */
export function emailListValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const addresses = parseAddresses(control.value);
  if (addresses.length === 0) return { required: true };
  return addresses.every((a) => looksLikeEmail(a)) ? null : { invalidEmail: true };
}
